import styled from 'styled-components';
import { Col } from 'reactstrap';
import { NavLink } from 'react-router-dom';
import colors from '../../../../includes/colors';

export const CategoryBox = styled(Col)`
  padding-right: 10px;
  transition: opacity 0.2s ease 0s;
  @media (min-width: 768px) {
    &:last-child {
      padding-right: 0 !important;
    }
  }
  &:hover {
    & > a {
      background-color: #eee;
      box-shadow: 1px 1px 3px 0 #c8c9c7;
      border-color: #0076ce;
      text-decoration: none;
    }
  }
`;

export const NavLinkTab = styled(NavLink)`
  display: inline-block;
  border: solid 1px #ccc;
  width: 100%;
  padding: 20px;
  height: 100%;
  margin-top: 1px;
  margin-left: 1px;
  &.is-active {
    border-color: #0076ce;
    border-width: 2px;
    margin-left: 0;
    margin-top: 0;
  }
`;

export const Title = styled.h2`
  font-size: 1.0625rem;
  line-height: 1.5rem;
  font-weight: 300;
  color: ${colors.blue};
  @media (min-width: 576px) {
    font-size: 1.25rem;
  }
`;

export const Tagline = styled.div`
  font-size: 0.875rem;
  color: #000;
`;
